import { UNADJUST_BILL_CREDIT_NOTE_REGISTER_REPORT_FAILURE, UNADJUST_BILL_CREDIT_NOTE_REGISTER_REPORT_REQUEST, UNADJUST_BILL_CREDIT_NOTE_REGISTER_REPORT_SUCCESS } from "../types";
  
  const initialState = {
    unadjustBillCreditNoteReport: {},
    loading: false,
    error: null,
  };
  
  const unadjustBillCreditNoteReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case UNADJUST_BILL_CREDIT_NOTE_REGISTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case UNADJUST_BILL_CREDIT_NOTE_REGISTER_REPORT_SUCCESS: {
        console.log("UNADJUST_BILL_CREDIT_NOTE_ Credit Note Return Payload",action.payload);
        
        return {
          ...state,
          unadjustBillCreditNoteReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case UNADJUST_BILL_CREDIT_NOTE_REGISTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default unadjustBillCreditNoteReportReducer;
  